import ComcastCode from "./ComcastCode";
import StyledQRCode from "./StyledQRCode";
import { getModel } from "../../utils/models";

const GenericSalesCard = ({ children, salesCTAText, salesPhone }) => {
    return (
        <div className="sales-card">
            <div className="sales-card-title">Don't have DAZN <br/>For Business?</div>
            <div className="sales-card-content">
                Get access to exclusive games and top sports content like NFL Sunday Ticket, Peacock Sports Pass and more!
            </div>
            <div className="horizontal-separator"></div>
            <div className="sales-card-footer">
                <div>
                    <div>{salesCTAText}</div>
                    <div>
                        <span className="span-semi-bold">{salesPhone}</span> to get started
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};

const ByodSalesCard = () => {
    return (
        <div className="sales-card">
            <div className="sales-card-title">Looking to Add DAZN For Business<br/>to Your Business?</div>
            <div className="sales-card-content">
                <div>Drive traffic and keep fans engaged</div>
                <div>with premium live sports, licensed</div>
                <div>for commercial venues.</div>
            </div>
            <div className="sales-card-footer">
                <StyledQRCode value="https://everpass.com" width={142} height={142} margin={4} style={{ borderRadius: "8px" }} />
            </div>
        </div>
    );
};

const SalesCard = ({ salesCTAText, salesPhone, onlyAvailableHelper }) => {
    const model = getModel();

    switch (model) {
        case "xumo":
            return (
                <GenericSalesCard salesCTAText={salesCTAText} salesPhone={salesPhone}/>
            );
        case "xi6":
        case "xid":
        case "xg2v2":
            return (
                <GenericSalesCard salesCTAText={salesCTAText} salesPhone={salesPhone}>
                    <ComcastCode />
                    {onlyAvailableHelper && (
                        <div className="activation-cta-footer">
                            <div>{onlyAvailableHelper}</div>
                        </div>
                    )}
                </GenericSalesCard>
            );
        case "lgwebos":
        case "samsungtizen":
        case "amazonvegaos":
        case "androidtv":
        case "firetv":
            return (
                <ByodSalesCard/>
            );
        default: 
            return (<></>);
    }
};

export default SalesCard;